import { useState, useEffect } from 'react';

export default function FellowshipPage() {
  const [html, setHtml] = useState('');

  useEffect(() => {
    fetch('/fellowship/index.html')
      .then(res => res.text())
      .then(setHtml)
      .catch(() => setHtml('<p>Failed to load page.</p>'));
  }, []);

  if (!html) return null;

  return (
    <iframe
      srcDoc={html}
      title="Sports Medicine Fellowship"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  );
}
